import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/areas/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/areas/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/areas/updateById', data)
}

// 查询就地存取规则列表
export function localStorage (cityId) {
  return request.get(`/business/pricingRule/localStorage/list?cityId=${cityId}`)
}

// 查询异地寄送规则列表
export function remoteDelivery (cityId) {
  return request.get(`/business/pricingRule/remoteDelivery/list?cityId=${cityId}`)
}

// 查询异地寄送规则列表
export function estimatedDelivery (cityId) {
  return request.get(`/business/pricingRule/estimatedDelivery/list?cityId=${cityId}`)
}

// 查询门店注册押金规则列表
export function storeDeposit (cityId) {
  return request.get(`/business/pricingRule/storeDeposit/list?cityId=${cityId}`)
}

// 查询分成比例规则列表
export function revenueShare (cityId) {
  return request.get(`/business/pricingRule/revenueShare/list?cityId=${cityId}`)
}

// 批量保存就地存取规则
export function batchSave (data) {
  return request.post('/business/pricingRule/localStorage/batchSave', data)
}

// 批量保存异地寄送规则
export function batchSaveRemoteDelivery (data) {
  return request.post('/business/pricingRule/remoteDelivery/batchSave', data)
}

// 批量保存预计时效配置
export function batchSaveEstimatedDelivery (data) {
  return request.post('/business/pricingRule/estimatedDelivery/save', data)
}

// 批量保存门店注册押金规则
export function batchSaveStoreDeposit (data) {
  return request.post('/business/pricingRule/storeDeposit/batchSave', data)
}

// 批量保存分成比例规则
export function batchSaveRevenueShare (data) {
  return request.post('/business/pricingRule/revenueShare/batchSave', data)
}
